import {useState} from 'react';

const useCheckboxState = (initialVal) => {

    const [value, setValue] = useState(initialVal);

    const setCheck = (e) => { 
        const status = e.target.checked;
        setValue(status);
    }

    return [value, setCheck];
}

export default useCheckboxState;
